const ProgressBarData01 = [
    {
        title:"Quality",
        value:"100",
    },
    {
        title:"Purity",
        value:"100",
    },
    {
        title:"Evolving Technologies",
        value:"85",
    },
]

const ProgressBarData02 = [
    {
        title:"DEVELOPMENT",
        value:"95",
    },
    {
        title:"PROMOTION",
        value:"85",
    },
    {
        title:"BRANDING",
        value:"75",
    },
]

export { ProgressBarData01 , ProgressBarData02}